import { useMemo, useState } from "react";
import { OPPORTUNITY_STATES_DATA } from "src/utils/constants";
import { translateOpportunityState } from "src/utils/translations";
import Select, { components } from 'react-select';
import { OpportunityStageEnum } from "src/api";
import { isNil } from 'lodash';

type Props = {
  onStageSelected: (stage: OpportunityStageEnum) => void;
  allowedStages?: OpportunityStageEnum[];
  isClearable?: boolean;
  defaultValue?: any
  isDisabled?: boolean;
}

const buildStageOption = (key: string) => ({
  value: key,
  label: translateOpportunityState(OPPORTUNITY_STATES_DATA[key]?.label) || key,
  cssClass: OPPORTUNITY_STATES_DATA[key]?.cssClass,
})

const DEFAULT_STAGE_OPTION = Object.keys(OPPORTUNITY_STATES_DATA)
  .filter(key => key === OpportunityStageEnum.proposal)
  .map(buildStageOption)
  .at(0);


export function OpportunityStagePicker({ allowedStages, onStageSelected, defaultValue, isClearable = false, isDisabled = false }: Props) {
  const [currentStage, setCurrentStage] = useState<any | null>(
    (defaultValue && buildStageOption(defaultValue))
    || { ...DEFAULT_STAGE_OPTION }
  );

  const stageOptions = useMemo(() => {
    return Object.keys(OPPORTUNITY_STATES_DATA)
      .sort((x, y) => (OPPORTUNITY_STATES_DATA[x]?.position || 0) - (OPPORTUNITY_STATES_DATA[y]?.position || 0))
      .map(buildStageOption)
      .filter(item => isNil(allowedStages) ? true : allowedStages?.includes(item.value as OpportunityStageEnum))
  }, [allowedStages]);


  return (
    <Select
      menuPosition="fixed"
      options={stageOptions}
      value={currentStage}
      isClearable={isClearable}
      isDisabled={isDisabled}
      styles={{
        control: (provided) => ({ ...provided, width: '300px' }),
      }}
      onChange={(item) => {
        setCurrentStage(item);
        onStageSelected(item?.value as OpportunityStageEnum)
      }}
      components={{
        Control: ({ children, ...props }) => (
          <components.Control {...props}>
            <div
              style={{ width: '3px', height: '25px' }}
              className={'m-1 bg-' + (currentStage?.cssClass || 'secondary')}
            ></div>
            {children}
          </components.Control>
        ),
        Option: (props) => (
          <div className='d-flex align-items-center'>
            <div
              style={{ width: '3px', height: '25px' }}
              className={'m-1 bg-' + (props.data.cssClass || 'secondary')}
            ></div>
            <components.Option {...props} />
          </div>
        )
      }}
    />
  )
}

export default OpportunityStagePicker;
